// components/ConfirmationModal.tsx
import { FC } from 'react';
import { useIntl } from 'react-intl';

type ConfirmationModalProps = {
    show: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
};

const ConfirmationModal: FC<ConfirmationModalProps> = ({ show, title, message, onConfirm, onCancel, isLoading }) => {
    const intl = useIntl();

    if (!show) return null;

    return (
        <>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
                <div className='modal-dialog modal-dialog-centered modal-md'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h3 className='modal-title'>{intl.formatMessage({ id: title })}</h3>
                        </div>
                        <div className='modal-body'>
                            <h5 className='text-center'>{intl.formatMessage({ id: message })}</h5>
                        </div>
                        <div className='modal-footer justify-content-evenly'>
                            <button type='button' className='btn btn-primary' onClick={onConfirm} disabled={isLoading}>
                                <span className='indicator-label'>{intl.formatMessage({ id: title })}</span>
                                {isLoading && (
                                    <span className='indicator-progress'>
                                        ...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                            <button type='button' className='btn btn-danger' onClick={onCancel} disabled={isLoading}>
                                <span className='indicator-label'>{intl.formatMessage({ id: 'CANCEL' })}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    );
};

export default ConfirmationModal;
